import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import SydButton from '../../../../../commonDesign/Button'
import Icon from '../../../../../atoms/Icon'

const useStyles = makeStyles(() => ({
  pillWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4px 0'
  },
  pillButton: {
    opacity: 0.6,
    transition: 'opacity 150ms ease-in-out',
    '&:hover': {
      opacity: 1
    },
    '&:disabled': {
      opacity: 0.4
    }
  },
  pillInner: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px'
  },
  confirmWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px'
  },
  confirmText: {
    color: 'var(--color-neutral-700)',
    textAlign: 'center',
    maxWidth: '360px',
    lineHeight: 1.4
  },
  confirmActions: {
    display: 'flex',
    gap: '8px'
  }
}))

function NewSessionPill ({ visible, disabled, onConfirm }) {
  const classes = useStyles()
  const [isConfirming, setIsConfirming] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (!visible) return null

  const handleConfirm = async () => {
    setIsSubmitting(true)
    try {
      await onConfirm()
      setIsConfirming(false)
    } finally {
      setIsSubmitting(false)
    }
  }

  if (isConfirming) {
    return (
      <div className={classes.confirmWrapper}>
        <span className={`${classes.confirmText} font-size-xs`}>
          End this conversation and start a new one?
        </span>
        <div className={classes.confirmActions}>
          <SydButton
            size='xs'
            variant='outline'
            onClick={() => setIsConfirming(false)}
            disabled={isSubmitting}
          >
            Cancel
          </SydButton>
          <SydButton
            size='xs'
            variant='ai'
            onClick={handleConfirm}
            processing={isSubmitting}
          >
            Confirm
          </SydButton>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.pillWrapper}>
      <SydButton
        size='xs'
        variant='outline'
        className={classes.pillButton}
        onClick={() => setIsConfirming(true)}
        disabled={disabled}
      >
        <span className={classes.pillInner}>
          <Icon name='addCircle' customSize={14} />
          <span className='font-size-xs'>New session</span>
        </span>
      </SydButton>
    </div>
  )
}

NewSessionPill.propTypes = {
  visible: PropTypes.bool,
  disabled: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired
}

NewSessionPill.defaultProps = {
  visible: false,
  disabled: false
}

export default NewSessionPill
